var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"f-size-medium button-radius no-shadow",style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    color: _vm.textColor,
    lineHeight: '100%'
  }),attrs:{"color":_vm.backgroundColor,"disabled":_vm.disabled,"loading":_vm.loading,"outline":_vm.outline},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }